import { Briefcase, MapPin, Users } from 'lucide-react'
import React from 'react'
import { useState } from 'react'
import Footer from '../Layout/Footer';
import Navbar from '../Layout/Navbar';
import ApplyNow from './ApplyNow';
import { postdata } from './CareersData'
import Jobdescription from './Jobdescription';

export default function Careers() {
    const [openjobdescription, setJobDescription] = useState(false);
    const [openapplynow, setApplynow] = useState(false);
    const [jobid, setJobid] = useState();
    const handlerjobdescription = (index) => {
        setJobDescription(prev => !prev)
        setJobid(index)

    }
    const handlerapplynow = () => {
        setApplynow(prev => !prev)
    }
    return (
        <>
        <Navbar />
        <div className='w-full bg-gray-100 h-auto pt-20'>

            <div className='bl-container'>
                <div className='w-full flex py-5 items-center flex-col justify-center'>
                    <h1 className='text-4xl font-extrabold font-sans text-blue-600'>Join Our Team</h1>
                    <p className='mt-5 text-xl text-center'> Explore exciting career opportunities and grow with us!</p>
                </div>

                {/* {careers post} */}
                <div className='grid md:grid-cols-2 gap-10 mt-5 items-stretch mb-5'>
                {postdata.map((items, index) => (
                    <div key={index} className='bg-white py-5 rounded-lg shadow-md p-6'>
                        <h1 className='text-xl font-semibold'>{items.position}</h1>

                        <div className='flex flex-wrap items-center mt-3 gap-3'>
                            <div className='flex items-center gap-3 text-gray-600'>
                                <Briefcase />
                                <h1>{items.experience} years experience</h1>
                            </div>
                            <div className='flex items-center gap-3 text-gray-600'>
                                <MapPin />
                                <h1>{items.location}</h1>
                            </div>
                            <div className='flex items-center gap-3 text-gray-600'>
                                <Users className='fill-gray-400 text-gray-400' />
                                <h1>{items.openingno} Openings</h1>
                            </div>
                        </div>
                        <p className=' text-gray-600 text-lg mt-5'>{items.description.split(' ').slice(0, 30).join(' ')}...</p>
                        <div className='mt-5 text-gray-600'>
                            {items.skill.map((lists, index) => (

                                <li key={index}>{lists}</li>
                            ))}

                        </div>
                        <div className=' flex items-start mt-5 gap-5'>
                            <button className='py-2 px-4 text-lg bg-gray-700 text-white rounded-md hover:bg-gray-800' onClick={() => handlerjobdescription(items.id)}> Job Description</button>

                            <button className='py-2 px-4 text-lg bg-blue-700 text-white rounded-md hover:bg-blue-800' onClick={handlerapplynow}> Apply Now</button>
                        </div>

                    </div>

                ))}
                {openjobdescription ?
                    <Jobdescription click={handlerjobdescription} jobindex={jobid} />
                    : ''

                }
                {openapplynow ?
                    <ApplyNow click={handlerapplynow} /> : ''}

                </div>
            </div>
            <Footer/>
        </div>
        </>
    )
}
